import { createStore, createEvent } from "effector";
import { Vehicle } from "../../types/vehicles.types";
import { vehiclesStoreState } from "./VehiclesStore.consts";
import { VehiclesStoreState } from "./VehiclesStore.types";
import {
  addVehicleEffect,
  deleteVehicleEffect,
  editVehicleEffect,
  getVehiclesEffect,
  getVehiclesByClientEffect,
  getVehiclesByFleetEffect,
} from "./VehiclesStore.effects";

export const resetVehiclesStore = createEvent();

export const VehiclesStore = createStore<VehiclesStoreState>(vehiclesStoreState)
  .on(getVehiclesEffect.doneData, (store, vehicles: Vehicle[]) => ({ ...store, vehicles }))
  .on(getVehiclesByClientEffect.doneData, (store, vehicles: Vehicle[]) => ({ ...store, vehicles }))
  .on(getVehiclesByFleetEffect.doneData, (store, vehicles: Vehicle[]) => ({ ...store, vehicles }))
  .on(addVehicleEffect.doneData, (store, newVehicle: Vehicle) => ({
    ...store,
    vehicles: [...store.vehicles, newVehicle],
  }))
  .on(editVehicleEffect.doneData, (store, edited: Vehicle) => ({
    ...store,
    vehicles: store.vehicles.map((v) => (v.id === edited.id ? edited : v)),
  }))
  .on(deleteVehicleEffect.doneData, (store, deletedId: string) => ({
    ...store,
    vehicles: store.vehicles.filter((v) => v.id !== deletedId),
  }))
  .reset(resetVehiclesStore);
